export default __webpack_public_path__ + "static/media/151-house.9cb5f8e8.png";